module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "list-input-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }],
    staticClass: "input-list-dropdown",
    attrs: {
      "readonly": !_vm.typeable,
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.inputValue)
    },
    on: {
      "click": function($event) {
        _vm.isListOpen = !_vm.isListOpen
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cursor-wrapper"
  }, [(!_vm.isListOpen) ? _c('i', {
    staticClass: "icon fa fa-chevron-down",
    on: {
      "click": function($event) {
        _vm.isListOpen = true
      }
    }
  }) : _c('i', {
    staticClass: "icon fa fa-chevron-up",
    on: {
      "click": function($event) {
        _vm.isListOpen = false
      }
    }
  })])]), _vm._v(" "), (_vm.isListOpen) ? _c('ul', {
    staticClass: "list-wrapper"
  }, _vm._l((_vm.options), function(option, index) {
    return _c('li', {
      key: index,
      staticClass: "list-option",
      style: (index !== 0 ? 'border-top: 1px solid #ced4da; text-align: left;' : 'text-align: left;'),
      on: {
        "click": function($event) {
          _vm.inputValue = option;
          _vm.isListOpen = false
        }
      }
    }, [_vm._v("\n      " + _vm._s(_vm.image) + _vm._s(option) + "\n    ")])
  }), 0) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-08ffeba8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08ffeba8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/listDropdownV2.vue
// module id = 2322
// module chunks = 2